export default () => {
  return { editorIsDiscarding: true };
};
